<template>
    <div class="content-wapper">

        <el-row class="navigation">
            <el-col align="left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '' }">小微驿站</el-breadcrumb-item>
                    <el-breadcrumb-item>党建引领</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="6" style="height: 100%;">
                <el-row class="left-img">
                    <img src="@/assets/images/xwqyczfw/djyl/djyl.png"/>
                </el-row>
                <el-row class="menu-box" style="min-height: 340px;">
                    <el-menu :default-active="menuCode"
                             class="el-menu-vertical-demo"
                             text-color="#000"
                             active-text-color="#409eff"
                             @select="handleSelect">
                        <template v-for="item in menulist">
                            <el-menu-item :index="item.code" >
                                <i :class="item.icon"></i>
                                <span>{{item.title}}</span>
                            </el-menu-item>
                        </template>
                    </el-menu>
                </el-row>
            </el-col>

            <el-col :span="18" class="right-box" >
                <el-row class="right-box-row" style="min-height: 430px;">
                    <el-row class="right-box-row-title">
                        {{menuTitle}}
                    </el-row>
					<div v-if="listshow && menuCode != 'cxgs'">
						<el-table v-loading="loading" :data="list" :show-header="false" tooltip-effect="light">
						    <el-table-column align="left" :show-overflow-tooltip="true" prop="title" class-name="title" >
						        <template slot-scope="scope">
						            <span @click="openPage(scope.row)">{{ scope.row.djylglTitle }}</span>
						        </template>
						    </el-table-column>
						    <el-table-column label="发布时间" align="center" prop="djylglFbtime" width="180">
						        <template slot-scope="scope">
						            <span>{{ parseTime(scope.row.djylglFbtime, '{y}-{m}-{d}') }}</span>
						        </template>
						    </el-table-column>
						</el-table>
						<pagination
						        v-show="total>0"
						        :total="total"
						        :page.sync="queryParams.pageNum"
						        :limit.sync="queryParams.pageSize"
						        @pagination="getList"
						/>
					</div>
					<div v-if="listshow && menuCode == 'cxgs'">
						<el-table v-loading="loading" :data="list" :show-header="false" tooltip-effect="light">
						    <el-table-column align="left" :show-overflow-tooltip="true" prop="title" class-name="title" >
						        <template slot-scope="scope">
						            <span @click="openCxPage(scope.row)">{{ scope.row.title }}</span>
						        </template>
						    </el-table-column>
						    <el-table-column label="发布时间" align="center" prop="fbtime" width="180">
						        <template slot-scope="scope">
						            <span>{{ parseTime(scope.row.fbtime, '{y}-{m}-{d}') }}</span>
						        </template>
						    </el-table-column>
						</el-table>
						<pagination
						        v-show="total>0"
						        :total="total"
						        :page.sync="queryParams.pageNum"
						        :limit.sync="queryParams.pageSize"
						        @pagination="getInfoPubList"
						/>
					</div>
                    <div v-if="!listshow">
						<el-form :model="pxsbForm" :rules="pxsbRules" ref="pxsbForm" label-width="100px">
							<el-form-item label="申报内容" prop="content">
							    <el-input type="textarea" v-model="pxsbForm.content"  maxlength="1000"
                            show-word-limit
								:autosize="{ minRows: 10, maxRows: 20}"></el-input>
							  </el-form-item>
							  <el-form-item>
							    <el-button type="primary" @click="submitPxsbForm()">立即申报</el-button>
							    <el-button @click="resetForm('pxsbForm')">重置</el-button>
							  </el-form-item>
						</el-form>
					</div>
                </el-row>
            </el-col>
        </el-row>

    </div>
</template>

<script>
    import {
        listDjylgl,
    } from "@/api/xwqy/djylgl";
    import {updatePvNum} from "@/api/itempv/pv";
	import { addPxsb } from "@/api/xwqy/djylpxsb";
	import {
	    listInfoPub,getInfoPub
	} from "@/api/xwqy/infopub";
	
    export default {
        name: "djyl",
        data() {
            return {
                menulist:[
                    {code:'tzgg',title:'通知公告',icon:'el-icon-reading'},
                    {code:'bzgb',title:'表彰通报',icon:'el-icon-reading'},
                    {code:'gqsdjgz',title:'各区市党建工作',icon:'el-icon-reading'},
                    {code:'gtsyqydjgz',title:'个体私营企业党建工作',icon:'el-icon-reading'},
					{code:'pxsb',title:'评选申报',icon:'el-icon-reading'},
                    {code:'cxgs',title:'撤销公示',icon:'el-icon-reading'}
                ],
                menuTitle:undefined,
                menuCode:undefined,
                // 遮罩层
                loading: false,
                // 总条数
                total: 0,
                list:[],
                queryParams:{
                    pageNum:1,
                    pageSize:10,
                    djylglType: undefined,
                },
				listshow:true,
				pxsbForm:{},
				pxsbRules:{
					content: [
						{ required: true, message: '请填写申报内容', trigger: 'blur' }
					]
				}
            }
        },
        created() {
            this.menuCode=this.menulist[0].code;
            this.menuTitle=this.menulist[0].title;
            this.getList(0);
        },
        methods: {
            toPage(url){
                this.$router.push({
                    path: url,
                });
                this.$store.commit('SET_MAININDEX', url);
            },
            refresh(){
                this.getList(0);
            },
            getList(djylglType) {
                this.queryParams.djylglType = djylglType;
                this.loading = true;
                listDjylgl(this.queryParams).then(response => {
                    this.list = response.rows;
                    this.total = response.total;
                    this.loading = false;
                });
            },
			getInfoPubList(type) {
				console.log(type)
			    this.queryParams.type = type;
			    this.loading = true;
			    listInfoPub(this.queryParams).then(response => {
			        this.list = response.rows;
			        this.total = response.total;
			        this.loading = false;
			    });
			},
            handleSelect(key, keyPath) {
                this.menuCode=key;
                for (let item of this.menulist){
                    if(item.code==key){
                        this.menuTitle=item.title;
                    }
                }
                this.queryParams.pageNum = 1;
                if(key=='tzgg'){
					this.listshow = true
                    //通知公告
                    this.getList(0);
                    updatePvNum("xwqycz_djyl_tzgg").then(response => {
                        //pv 点击党建引领通知公告
                    });
                }else if(key=='bzgb'){
					this.listshow = true
                    //表彰通报
                    this.getList(1);
                    updatePvNum("xwqycz_djyl_bztb").then(response => {
                        //pv 点击党建引领表彰通报
                    });
                }else if(key=='gqsdjgz'){
					this.listshow = true
                    //各区市党建工作
                    this.getList(2);
                    updatePvNum("xwqycz_djyl_gqsdjgz").then(response => {
                        //pv 点击党建引领各区市党建工作
                    });
                }else if(key=='gtsyqydjgz'){
					this.listshow = true
                    //个体私营企业党建工作
                    this.getList(3);
                    updatePvNum("xwqycz_djyl_gtsyqydjgz").then(response => {
                        //pv 点击党建引领个体私营企业党建工作
                    });
                }else if(key=='cxgs'){
					this.listshow = true
                    //撤销通告
                    this.getInfoPubList(1);
                    updatePvNum("yw_xwqy_info_pub").then(response => {
                        //pv 点击党建引领撤销公示
                    });
                } else if (key == 'pxsb') {
					this.listshow = false
				}
            },
            openDetail(item){
                this.$router.push({
                    path: '/main/xwqyczfw/djyl/detail/'+this.menuCode+'/'+item.recid
                })
                this.$store.commit('SET_MAININDEX', '/main/djyl');
            },
            openPage(item){
                this.utils.windowOpen('/main/xwqyczfw/djyl/detail/'+this.menuCode+'/'+item.recid);
            },
          openCxPage(item){
            this.utils.windowOpen('/main/xwqyczfw/djyl/cxdetail/'+this.menuCode+'/'+item.recid);
          },
			submitPxsbForm () {
				if (this.utils.isLoginTimeout()) {
					let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
					if(ssessionLoginUser != null && ssessionLoginUser != undefined){
						this.$refs["pxsbForm"].validate(valid => {
              console.log("22222",ssessionLoginUser)
							this.pxsbForm.ywFwjgRecid = ssessionLoginUser.user.ywFwjgRecid;
							this.pxsbForm.applyName = ssessionLoginUser.ywFwjg.name;
						    if (valid) {
								let that  = this;
								this.$confirm(`是否提交申报?`, '提示', {
									confirmButtonText: '确定',
									cancelButtonText: '取消',
									type: 'warning'
								}).then(() => {
                  console.log("111111",this.pxsbForm)
									addPxsb(that.pxsbForm).then(response => {
									    if (response.code === 200) {
									        that.msgSuccess("成功");
									        that.pxsbForm = {}
									    } else {
									        that.msgError(response.msg);
									    }
									});
								})
						    }
						})
					}
				} else {
					this.$confirm('您未登录或登录已过期，您可以继续留在该页面，或者重新登录?', '提示', {
					    confirmButtonText: '确定',
					    cancelButtonText: '取消',
					    type: 'warning'
					}).then(() => {
					    this.logout(this.ywFwjgRecid)
					})
				}
			}
        }
    }
</script>

<style scoped>
    .content-wapper{
        margin-top: 5px;
        padding: 10px;
    }
    .navigation{
        padding:20px 15px;
        line-height: 20px;
        height: 60px;
        background-color: #F5F5F5;
        margin-bottom: 15px;
    }
    .left-img img{
        width: 100%;
    }
    .menu-box{
        background-color: #FAFAFA;
        padding: 15px 10px;
    }
    /deep/.el-menu{
        text-align: left;
        background-color:#FAFAFA;
        border:0;
    }
    .el-menu-item{
        margin-bottom: 10px;
        background-color:#EAEAEA;
    }
    .menu-box /deep/ .el-menu-item.is-active{
        background-color:#EBEFF8;
    }
    .right-box{
        padding-left: 10px;
    }
    .right-box-row{
        border: 1px solid #cccccc;
        padding: 10px 15px 0;
    }
    .right-box-row-title{
        padding: 15px 0;
        text-align: left;
        color: #409eff;
        font-size: 18px;
        font-weight: bold;
        border-bottom: 1px solid #cccccc;
        margin: 10px 0;
    }
    /deep/.title:hover{
        color: #1482f0;
        cursor: pointer;
    }
</style>